// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js","989":"component---src-templates-blog-post-js"}[chunkId] + "-" + {"678":"2ca5473284a53100e4e0","883":"90d45006c88912704274","989":"d229206c7698669abdd8"}[chunkId] + ".js";
};